// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/workflows/:workflowId\",\"regex\":\"^/workflows/([^/]+)$\",\"paramNames\":[\"workflowId\"],\"hasOptionalPrefix\":false},{\"path\":\"/credentials/:credentialId\",\"regex\":\"^/credentials/([^/]+)$\",\"paramNames\":[\"credentialId\"],\"hasOptionalPrefix\":false},{\"path\":\"/executions/:executionId\",\"regex\":\"^/executions/([^/]+)$\",\"paramNames\":[\"executionId\"],\"hasOptionalPrefix\":false},{\"path\":\"/webhooks/stripe/:endpointId\",\"regex\":\"^/webhooks/stripe/([^/]+)$\",\"paramNames\":[\"endpointId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/accept-invitation\"},{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/reset-password\"},{\"path\":\"/credentials\"},{\"path\":\"/credentials/new\"},{\"path\":\"/executions\"},{\"path\":\"/overview\"},{\"path\":\"/settings\"},{\"path\":\"/wireframes\"},{\"path\":\"/workflows\"},{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/contact\"},{\"path\":\"/developers\"},{\"path\":\"/faq\"},{\"path\":\"/features\"},{\"path\":\"/integrations\"},{\"path\":\"/pricing\"},{\"path\":\"/privacy\"},{\"path\":\"/product\"},{\"path\":\"/security\"},{\"path\":\"/templates\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.8";import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  "https://921d6aa87a611c118702a08c5eb64d28@o4510200123817984.ingest.us.sentry.io/4510200124866560";

// Allow runtime control over Replay (use NEXT_PUBLIC_SENTRY_ENABLE_REPLAY=false to disable)
const enableReplay = process.env.NEXT_PUBLIC_SENTRY_ENABLE_REPLAY !== "false";
const defaultReplaysOnError = process.env.NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR
  ? Number(process.env.NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR)
  : 0.5;

Sentry.init({
  dsn: SENTRY_DSN,

  // Add optional integrations for additional features. Include Replay only if enabled.
  integrations: enableReplay ? [Sentry.replayIntegration()] : [],

  // Define how likely traces are sampled. Lower sampling in development to reduce noise.
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 0.05,
  // Keep client logging quieter in production.
  enableLogs: process.env.NODE_ENV !== "production",

  // Define how likely Replay events are sampled.
  replaysSessionSampleRate: enableReplay
    ? process.env.NODE_ENV === "production"
      ? 0.01
      : 0.05
    : 0,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: enableReplay ? defaultReplaysOnError : 0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: process.env.NODE_ENV !== "production",
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
